export default __webpack_public_path__ + "static/media/publisher.6ae50558.svg";